import $ from 'jquery';

const codes = [
  46, // Delete
  8,  // Backspace
  9,  // Tab
  27, // Escape
  16, // Shift
  13, // Enter

  37, // Left Arrow
  38, // Up Arrow
  39, // Right Arrow
  40, // Down Arrow

  96,  // Numpad 0
  97,  // Numpad 1
  98,  // Numpad 2
  99,  // Numpad 3
  100, // Numpad 4
  101, // Numpad 5
  102, // Numpad 6
  103, // Numpad 7
];

const numCodes = [
  48, // 0
  49, // 1
  50, // 2
  51, // 3
  52, // 4
  53, // 5
  54, // 6
  55, // 7
  56, // 8
  57, // 9
];

const KEY_PERIOD = 190;

$(_ => {

  $('.js-input-restrict-numbers').on('keydown', event => {

    const $input = $(event.target);
    const key = event.which;

    let valid = false;

    switch (true) {
      case codes.includes(key):
      case numCodes.includes(key) && !event.shiftKey:
      case key === 65 && event.ctrlKey: // Ctrl + A
      case key === 65 && event.metaKey: // Cmd + A
      case key === KEY_PERIOD && $input.prop('value').indexOf('.') === -1:
        valid = true;
        break;
    }

    if (valid) {
      $input.trigger('number-value-change');
    } else {
      event.preventDefault();
    }
  });


});